// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1ZBCg","rotate-ltr":"_1PlTQ","rotateLtr":"_1PlTQ","rotate-rtl":"MK8NB","rotateRtl":"MK8NB"};